// extracted by mini-css-extract-plugin
export default {"chevron":"Chevron_chevron__CugBC","active":"Chevron_active__dslij"};